import React from "react";
import { connect } from "react-redux";
import { fetchProcessingReport } from "../../queries/reconciliation/reconciliationQuery";
import language from "../../language";
import { Tabs } from "../Tabs";
import { Table } from "../Table";
import { getStorage } from "../../utils/storage";
import TransactionPanelTab from "../Transactions/TransactionPanelTab";

class ProcessReport extends React.Component {
  state = {
    isLoading: false,
    selected_data: {},
    data: {},
    mpesaData: [],
    airtelData: [],
    tokenData: [],
    cnpData: [],
    mpesaReversalData: [],
    airtelReversalData: [],
    tokenReversalData: [],
    cnpReversalData: [],
  };

  componentDidMount() {
    this.getData(true);
  }

  filtersParams = async () => {
    let { reconciliationPublicId } = this.props;

    const { merchantID } = await getStorage("merchantID");

    let params = {
      merchantId: merchantID,
      reconciliationPublicId,
    };

    return params;
  };

  getData = async (isLoading) => {
    const { defaultLanguage, reconciliationPublicId } = this.props;

    try {
      this.setState({ isLoading });

      const { merchantID } = await getStorage("merchantID");

      const params = {
        reconciliationPublicId,
        merchantId: merchantID,
      };

      const data = await fetchProcessingReport(defaultLanguage, params);

      const transactionTypes =
        data?.processingStatement?.transactionTypeReport || [];
      let mpesaData = [],
        airtelData = [],
        tokenData = [],
        cnpData = [],
        mpesaReversalData = [],
        airtelReversalData = [],
        tokenReversalData = [],
        cnpReversalData = [];

      transactionTypes.forEach((transactionType) => {
        const paymentModes = transactionType?.paymentModeReport || [];

        paymentModes.forEach((mode) => {
          const { paymentMode, transactionResultReport } = mode;

          if (transactionType.type === "PaymentTransaction") {
            if (paymentMode === "Mpesa")
              mpesaData = transactionResultReport || [];
            if (paymentMode === "Airtel")
              airtelData = transactionResultReport || [];
            if (paymentMode === "Token")
              tokenData = transactionResultReport || [];
            if (paymentMode === "CNP") cnpData = transactionResultReport || [];
          }

          if (transactionType.type === "ReversalTransaction") {
            if (paymentMode === "Mpesa")
              mpesaReversalData = transactionResultReport || [];
            if (paymentMode === "Airtel")
              airtelReversalData = transactionResultReport || [];
            if (paymentMode === "Token")
              tokenReversalData = transactionResultReport || [];
            if (paymentMode === "CNP")
              cnpReversalData = transactionResultReport || [];
          }
        });
      });

      this.setState({
        isLoading: false,
        data: data,
        mpesaData,
        airtelData,
        tokenData,
        cnpData,
        mpesaReversalData,
        airtelReversalData,
        tokenReversalData,
        cnpReversalData,
      });
    } catch (error) {
      console.error(error);
      this.setState({ isLoading: false });
    }
  };

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].run_number,
        key: "noOfTransactions",
      },
      {
        title: language[this.props.defaultLanguage].transaction_date,
        key: "transactionDate",
      },
      {
        title: language[this.props.defaultLanguage].label,
        key: "label",
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
      },
    ];

    return headers;
  }

  renderData = (data) => {
    return (
      <Table
        data={data}
        isLoading={this.state.isLoading}
        headers={[
          {
            title: "No of transactions",
            key: "noOfTransactions",
          },
          {
            title: "Transaction Result",
            key: "transactionResult",
            type: "status",
          },
          {
            title: "Total Amount",
            key: "totalAmount",
          },
          {
            title: "Fees",
            key: "fees",
          },
          {
            title: "Amount Confirmed",
            key: "amountConfirmed",
          },
          {
            title: "Amount Not Confirmed",
            key: "amountNotConfirmed",
          },
        ]}
      />
    );
  };

  render() {
    return (
      <div className="card-body">
        <Tabs
          options={[
            {
              title: language[this.props.defaultLanguage].payments,
              data: (
                <Tabs
                  options={[
                    {
                      title: "Mpesa",
                      data: <div>{this.renderData(this.state.mpesaData)}</div>,
                    },
                    {
                      title: "Airtel",
                      data: <div>{this.renderData(this.state.airtelData)}</div>,
                    },
                    {
                      title: "Card not Present",
                      data: <div>{this.renderData(this.state.cnpData)}</div>,
                    },
                    {
                      title: "Token",
                      data: <div>{this.renderData(this.state.tokenData)}</div>,
                    },
                  ]}
                />
              ),
            },
            {
              title: language[this.props.defaultLanguage].reversals,
              data: (
                <Tabs
                  options={[
                    {
                      title: "Mpesa",
                      data: (
                        <div>
                          {this.renderData(this.state.mpesaReversalData)}
                        </div>
                      ),
                    },
                    {
                      title: "Airtel",
                      data: (
                        <div>
                          {this.renderData(this.state.airtelReversalData)}
                        </div>
                      ),
                    },
                    {
                      title: "Card not Present",
                      data: (
                        <div>{this.renderData(this.state.cnpReversalData)}</div>
                      ),
                    },
                    {
                      title: "Token",
                      data: (
                        <div>
                          {this.renderData(this.state.tokenReversalData)}
                        </div>
                      ),
                    },
                  ]}
                />
              ),
            },
          ]}
        />
        {
          <>
            <hr />
            {this.state.data?.stores && this.state.data?.stores.length > 0 && (
              <TransactionPanelTab data={this.state.data?.stores || []} />
            )}
          </>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ProcessReport);
